import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import BusComponent from '../BusComponent';

import TextInput from '../form/TextInput';
import googleTagManagerEvents from '../../helpers/GoogleTagManagerEventsWrapper';
import { saveAsProjectEvents } from '../../enums/GoogleTagManagerEvents';

const SaveButton = googleTagManagerEvents('button', saveAsProjectEvents);

class SaveProjectPopup extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            title: '',
            description: '',
            isCopy: this.props.isCopy,
            isEdit: this.props.isEdit,
        };

        this.bindGluBusEvents({
            SAVE_PROJECT_SUCCESS: this.onClose,
            PROJECT_UPDATE_SUCCESS: this.onClose,
        });
        this.boundOnCurrentProjectRetrieved = this.onCurrentProjectRetrieved;
    }

    componentDidMount() {
        const { intl } = this.props;
        const { isEdit } = this.state;

        if (isEdit) {
            this.bus.on('CURRENT_PROJECT', this.boundOnCurrentProjectRetrieved);
            this.emit('CURRENT_PROJECT_REQUEST', { source: this });
        }

        this.saveButton.setCustomAttribute('gtm-eventc', 'Map projects');
        this.saveButton.setCustomAttribute(
            'gtm-eventa',
            isEdit ? intl.formatMessage({ id: 'saveChanges' }) : intl.formatMessage({ id: 'save' }),
        );
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onCurrentProjectRetrieved = eventMap => {
        if (eventMap.target === this) {
            this.bus.off('CURRENT_PROJECT', this.boundOnCurrentProjectRetrieved);
            this.setState({
                title: eventMap.project.title || '',
                description: eventMap.project.description || '',
            });
        }
    };

    onSave = () => {
        const { title, description, isEdit } = this.state;

        if (!title.trim()) return;

        const eventName = isEdit
            ? 'PROJECT_UPDATE_REQUEST'
            : 'SAVE_AS_NEW_PROJECT_REQUEST';

        this.emit(eventName, {
            title,
            description,
        });
    };

    onClickCopy = () => {
        this.emit('CLOSE_MODAL');
        const newTitle = `Copy of ${this.state.title}`;
        this.emit('COPY_PROJECT_POPUP_REQUEST', {
            visualReport: {
                ...this.props.visualReport,
                title: newTitle,
            },
            areaSelectorEnabled: this.props.areaSelectorEnabled,
        });

        this.setState({
            title: newTitle,
            isCopy: true,
            isEdit: false,
        });
    };

    onClose = () => {
        this.emit('CLOSE_MODAL');
    };

    render() {
        const { intl } = this.props;
        const { title, description, isEdit, isCopy } = this.state;

        const disabled = !title.trim();

        const saveTextId = isEdit ? 'saveChanges' : isCopy ? 'saveCopy' : 'save';

        return (
            <div className="save-as-project-content">
                <TextInput
                    initialFocus
                    className="new-project-title"
                    value={title}
                    placeholder={intl.formatMessage({ id: 'untitledProject' })}
                    onChange={value => {
                        this.setState({ title: value });
                    }}
                    onEnter={this.onSave}
                    label={intl.formatMessage({ id: 'title' })}
                />
                <TextInput
                    multiline
                    className="new-project-description"
                    value={description}
                    placeholder={intl.formatMessage({ id: 'descriptionOptional' })}
                    onChange={value => {
                        this.setState({ description: value });
                    }}
                    onEnter={this.onSave}
                />
                <div className="save-as-project-actions flex-it center space-between">
                    <div>
                        {isEdit && (
                            <button className="btn-flat" onClick={this.onClickCopy} data-testid="save-map-copy">
                                {intl.formatMessage({ id: 'saveCopy' })}...
                            </button>
                        )}
                    </div>
                    <div className="flex-it">
                        <button className="btn-flat" onClick={this.onClose}>
                            {intl.formatMessage({ id: 'cancel' })}
                        </button>

                        <SaveButton
                            ref={c => {
                                this.saveButton = c;
                            }}
                            className="btn-raised"
                            onClick={this.onSave}
                            disabled={disabled}
                            data-testid="save-map-submit"
                        >
                            {intl.formatMessage({ id: saveTextId })}
                        </SaveButton>
                    </div>
                </div>
            </div>
        );
    }
}
SaveProjectPopup.propTypes = {
    isEdit: PropTypes.bool,
    isCopy: PropTypes.bool,
    intl: PropTypes.object.isRequired,
};

SaveProjectPopup.defaultProps = {
    isEdit: false,
    isCopy: false,
};

export default injectIntl(SaveProjectPopup);
